import { AudioManager } from "./AudioManager";
import { GameVars } from "./GameVars";
import { Button } from "./utils/Button";

export class AudioControlsContainer extends Phaser.GameObjects.Container {

    private soundTrackOnButton: Button;
    private soundTrackOffButton: Button;
    private fxOnButton: Button;
    private fxOffButton: Button;
    
    constructor(scene: Phaser.Scene) {
        
        super(scene);

        const gameText = this.scene.cache.json.get("text"); 
        const lan = GameVars.gameData.data.language;

        const soundLabel = new Phaser.GameObjects.Text(this.scene, -60, -44, gameText["SOUND_FX"][lan], {fontFamily: "OpenSans-CondLight", fontSize: "45px", color: "#7C5D46"});
        soundLabel.setOrigin(1, .5);
        this.add(soundLabel);

        const musicLabel = new Phaser.GameObjects.Text(this.scene, -60, 44, gameText["MUSIC"][lan], {fontFamily: "OpenSans-CondLight", fontSize: "45px", color: "#7C5D46"});
        musicLabel.setOrigin(1, .5);
        this.add(musicLabel);

        this.fxOnButton = new Button(this.scene, 0, -44, "texture_atlas_1", "btn_audio_on_off", "btn_audio_on_on");
        this.fxOnButton.onDown(this.onClickFxButton, this);
        this.add(this.fxOnButton);

        this.fxOffButton = new Button(this.scene, 0, -44, "texture_atlas_1", "btn_audio_off_off", "btn_audio_off_on");
        this.fxOffButton.onDown(this.onClickFxButton, this);
        this.add(this.fxOffButton);

        this.fxOnButton.visible = !GameVars.gameData.data.fxMuted;
        this.fxOffButton.visible = GameVars.gameData.data.fxMuted;

        this.soundTrackOnButton = new Button(this.scene, 0, 44, "texture_atlas_1", "btn_audio_on_off", "btn_audio_on_on");
        this.soundTrackOnButton.onDown(this.onClickSoundtrackButton, this);
        this.add(this.soundTrackOnButton);

        this.soundTrackOffButton = new Button(this.scene, 0, 44, "texture_atlas_1", "btn_audio_off_off", "btn_audio_off_on");
        this.soundTrackOffButton.onDown(this.onClickSoundtrackButton, this);
        this.add(this.soundTrackOffButton);

        this.soundTrackOnButton.visible = !GameVars.gameData.muted;
        this.soundTrackOffButton.visible = GameVars.gameData.muted; 
    }

    private onClickSoundtrackButton(): void {

        AudioManager.toggleAudioState(true);

        this.soundTrackOnButton.visible = !GameVars.gameData.muted;
        this.soundTrackOffButton.visible = GameVars.gameData.muted;

        AudioManager.playSound("btn_press");
    }

    private onClickFxButton(): void {

        AudioManager.toggleAudioState(false);

        this.fxOnButton.visible = !GameVars.gameData.data.fxMuted;
        this.fxOffButton.visible = GameVars.gameData.data.fxMuted;

        AudioManager.playSound("btn_press");
    }

}
